import axios from '../axios/http'
import { AxiosResponse, Canceler, ResponseType } from 'axios'
import { message } from 'ant-design-vue'
import router from '@/router/index'
import { userPinia } from '@/store/user'
// import { Router, useRouter } from 'vue-router'
import { loadingPinia } from '@/store/loading'
import invoicingPinia from '@/store/invoicing'
import requestConfig from './config'
import { trimSpace } from '@/utils/common'
import { CommonType } from '@/interface/index'

let curInterfaceName = ''
let logout: () => void
let toggleLoading: (status: boolean) => void
let setDownloadFileName: (str: string) => void
// let router: Router
type DataType = object | string | number | null | undefined
// get请求参数转换
function serialization(obj: DataType, type: string): string {
  const { entries } = Object
  let getParams = ''
  if (obj) {
    getParams = '?'
    if (type === '2') {
      getParams = ''
    }
    for (const [key, value] of entries(obj)) {
      if (type === '2') {
        // 斜杠拼接
        getParams += `/${value}`
      } else {
        // ?号和&号拼接
        getParams += `${key}=${value}&`
      }
    }
    if (type !== '2') {
      getParams = getParams.substring(0, getParams.length - 1)
    }
  }
  return getParams
}
function getGuration(text: string): number {
  let duration = Math.ceil(text.length / 8) * 3
  if (duration > 20) {
    duration = 20
  }
  return duration
}
function dealError(err: CommonType): void {
  let text = '服务器异常，请稍后重试'
  if (err && err?.code === 'ERR_CANCELED') return
  if (err && (err.response || err.status)) {
    const status = err.response ? err.response.status : err.status
    if (status === 401) {
      text = '登录已过期，请重新登录'
    } else if (status === 404) {
      text = '请求地址不存在'
    } else if (status === 403) {
      text = '请求权限不足'
    } else if (status === 405) {
      text = '请求跨越'
    } else {
      const data = err && err.response && err.response.data
      if (data && (data.message || data.msg)) {
        text = data.message || data.msg
      }
    }
  }
  message.error({
    content: text,
    duration: getGuration(text),
    style: { zIndex: 9999 }
  })
}
function dealBlob(data: Blob) {
  // 创建一个 FileReader 对象
  const reader = new FileReader()

  // 定义一个事件处理函数，当读取完成时执行
  reader.onload = function (event: CommonType) {
    // event.target.result 就是转换后的 ArrayBuffer
    const arrayBuffer = event.target.result
    const decoder = new TextDecoder('utf-8')
    const data = decoder.decode(arrayBuffer)
    try {
      if (data) {
        const cur = JSON.parse(data)
        message.error({
          content: cur.msg || '服务器异常，请稍后重试',
          style: { zIndex: 9999 }
        })
      }
    } catch (error) {
      console.error(error)
      message.error({
        content: '服务器异常，请稍后重试',
        style: { zIndex: 9999 }
      })
    }
    // 你可以在这里使用 arrayBuffer 进行其他操作
  }

  // 使用 FileReader 的 readAsArrayBuffer 方法读取 Blob
  reader.readAsArrayBuffer(data)
}
function dealThenData<T>(res: AxiosResponse<T>, isClose: boolean): T | null | AxiosResponse<T> {
  const headers = res.headers
  if (headers['content-disposition']) {
    const arr = headers['content-disposition'].split(';')
    const arr1 = arr.length ? arr[1].split('=') : []
    const str = arr1[1] || ''
    console.log(str)
    setDownloadFileName(str.replace(/"/g, ''))
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let data: any = res.data
  if (toString.call(data) === '[object Blob]' && headers['content-type'].includes('application/json')) {
    // 使用TextDecoder转换流数据为字符串
    dealBlob(data as Blob)
    data = null
  }
  let result = data
  isClose && toggleLoading(false)
  if (['rpaSmjg', 'rpaLoginStatus'].includes(curInterfaceName)) {
    return res.data
  }
  if (data && (data as CommonType).code) {
    const code = (data as CommonType).code
    if ([0, '0000', 10000004].includes(code)) {
      result = data
      return result
    } else if ([302].includes(code)) {
      // 1001
      toggleLoading(false)
      logout()
      if (router && !router.currentRoute.value.fullPath.includes('login')) {
        router.push({
          path: '/login',
          query: {
            redirect: router.currentRoute.value.fullPath
          }
        })
        message.error({
          content: (data as CommonType).msg,
          style: { zIndex: 9999 }
        })
      }
      return null
    } else {
      toggleLoading(false)
      const text = data ? (data as CommonType).msg || '服务器异常，请稍后重试' : ''
      message.error({
        content: text,
        duration: getGuration(text),
        style: { zIndex: 9999 }
      })
      return null
    }
  } else {
    return data
  }
}
const responseTypeObj: {
  [key: string]: ResponseType
} = {
  '1': 'json',
  '2': 'json',
  '3': 'json',
  '4': 'blob',
  '5': 'arraybuffer'
}
const curRequestObj: {
  [key: string]: Canceler | null
} = {}
/**
 *
 * @param {String} interfaceName 请求接口名称
 * @param {any} parameter 请参数
 * @param {String} parameterWay 参数方式 默认 '1': ?a=b  '2': /b '3': formData '4': 返回blob '5': arraybuffer
 * @param {Boolean} isClose 是否关闭加载框 true 关闭 false 不关闭
 * @param {Boolean} isOpen 是否打开加载框 true 打开 false 不打开
 * @param {string} urlParameter 地址后面跟随的参数
 */
export function ajaxApi<T>(
  interfaceName: string,
  parameter: DataType,
  parameterWay = '',
  isClose = true,
  isOpen = true,
  urlParameter = ''
): Promise<T> {
  logout = userPinia().logout
  toggleLoading = loadingPinia().toggleLoading
  setDownloadFileName = invoicingPinia().setDownloadFileName
  if (isOpen) {
    toggleLoading(true)
  }
  curInterfaceName = interfaceName
  try {
    // router = useRouter()
    const curData = requestConfig[interfaceName]
    const method = curData.method
    if (method === 'get') {
      return axios
        .get<AxiosResponse<T>>(curData.url + urlParameter + serialization(parameter, parameterWay), {
          responseType: responseTypeObj[parameterWay],
          cancelToken: new axios.CancelToken(function (c: Canceler) {
            if (
              curRequestObj[interfaceName] &&
              !['fpcyFileUpload', 'regenFpFile', 'sxedgx', 'qyxxGx'].includes(interfaceName)
            ) {
              curRequestObj[interfaceName]?.()
            }
            curRequestObj[interfaceName] = c
          })
        })
        .then((res: AxiosResponse) => {
          const result = dealThenData(res, isClose)
          curRequestObj[interfaceName] = null
          return result
        })
        .catch((err: CommonType) => {
          toggleLoading(false)
          if (err?.code === 'ERR_CANCELED') {
            curRequestObj[interfaceName] = null
            dealError(err)
          }
        })
    } else {
      let body: DataType = ''
      const valType = toString.call(parameter)
      switch (valType) {
        case '[object String]':
          body = ''
          break
        case '[object Array]':
        case '[object FormData]':
          body = valType === '[object Array]' ? trimSpace(parameter as CommonType[]) : parameter
          break
        case '[object Null]':
          body = undefined
          break
        default:
          body = {
            ...trimSpace(parameter as object),
            isEncrypt: curData.isEncrypt
          }
      }
      return axios
        .post(curData.url + urlParameter + `${typeof parameter === 'string' ? parameter : ''}`, body, {
          responseType: responseTypeObj[parameterWay],
          headers: ['4', '5'].includes(parameterWay)
            ? {}
            : {
                'Content-Type': parameterWay == '3' ? 'application/x-www-form-urlencoded' : 'application/json'
              },
          cancelToken: new axios.CancelToken(function (c) {
            if (
              curRequestObj[interfaceName] &&
              !['fpcyFileUpload', 'regenFpFile', 'sxedgx', 'qyxxGx'].includes(interfaceName)
            ) {
              curRequestObj[interfaceName]?.()
            }
            curRequestObj[interfaceName] = c
          })
        })
        .then((res: AxiosResponse) => {
          curRequestObj[interfaceName] = null
          const result = dealThenData(res, isClose)
          return result
        })
        .catch((err: CommonType) => {
          toggleLoading(false)
          if (err?.code !== 'ERR_CANCELED') {
            curRequestObj[interfaceName] = null
            dealError(err)
          }
        })
    }
  } catch (error) {
    curRequestObj[interfaceName] = null
    toggleLoading(false)
    return new Promise(() => null)
  }
}
